import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import AuthContext from "../../contexts/AuthProvider";
import cx from "classnames";
import { Grid } from "react-loader-spinner";
import useThemeColors from "../../hooks/useThemeColors";

import { makeStyles } from "@material-ui/core/styles";

const FADE_PERIOD = 300;

const styles = {
  root: {
    zIndex: "1031", // 1 less than sidebar
    position: "fixed",
    bottom: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "#fafafa",
    overflow: "hidden",
    display: "flex",
    alignItems: "top",
    justifyContent: "center",
    transition: "all " + FADE_PERIOD + "ms ease-in-out",
    "&.invisible": {
      height: "0",
      opacity: "0",
    },
  },
  faded: {
    opacity: "0",
  },
  centerAbsolute: {
    position: "absolute",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  loaderWrapper: {
    position: "absolute",
    top: "44%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
  },
  pleaseWait: {
    fontSize: "16px",
  },
  logo: {
    top: "90%",
  },
};
const useStyles = makeStyles(styles);

export default function FullPageLoader(props) {
  let { userDetails } = useContext(AuthContext);
  const { clientColor } = useThemeColors();
  const classes = useStyles();

  const { t } = useTranslation();
  const { isVisible } = props;
  const [faded, setFaded] = useState(true);
  const [viewContent, setViewContent] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setFaded(false);
    }, FADE_PERIOD);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      const removeContent = setInterval(() => {
        setViewContent(false);
      }, FADE_PERIOD);
      return () => clearInterval(removeContent);
    }
  }, [isVisible]);

  return (
    viewContent && (
      <div
        className={cx({
          [classes.root]: true,
          ["invisible"]: !isVisible,
        })}
      >
        <div
          style={{
            zIndex: "1031", // 1 less than sidebar
            width: "100%",
            height: "100%",
            position: "relative",
            transition: "opacity " + FADE_PERIOD + "ms",
          }}
          className={cx({
            [classes.faded]: faded,
          })}
        >
          <div className={classes.loaderWrapper}>
            <div className={classes.pleaseWait}>{t("preparing_your_data")}</div>
            <div>
              <Grid width={40} height={40} color={clientColor} />
            </div>
          </div>
          <div className={classes.centerAbsolute + " " + classes.logo}>
            <img
              src={`data:image/png;base64,${encodeURIComponent(userDetails.implementation_logo)}`}
              style={{ maxWidth: "180px", maxHeight: "180px" }}
              alt="logo"
            />
          </div>
        </div>
      </div>
    )
  );
}

FullPageLoader.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};
